<app-breadcrumb></app-breadcrumb>

<div class="row mx-1">
     <div class="col-12">

          CLAVE, es una empresa que inicia en el año 2013 siendo la primera tienda en México especializada en
          instrumentos y accesorios de aliento.
          Comenzó como un pequeño negocio que vendía a través de facebook y pronto llegó a ser una empresa que se
          consolidó como la favorita de los instrumentistas de aliento en México.
          <br> <br>
          Sabemos que para el músico profesional, su instrumento y accesorios son parte muy importante de su vida
          cotidiana. Tenemos la experiencia de cómo se siente un músico al adquirir
          cómodamente y a buen precio sus accesorios favoritos. También somos conscientes de que el músico principiante
          requiere apoyo para escoger los productos que realmente necesita.
          En CLAVE no nos gusta ofrecer “lo que hay”, sino que tratamos de tener la mejor opción para cada músico.
          <br> <br>
          Nuestro principal objetivo es servir y prepararnos cada vez mejor para hacerlo más eficazmente. Queremos que
          el saxofonista, trombonista, clarinetista, flautista, oboista,
          fagotista, cornista, tubista, trompetista, tenga un gran catálogo, bien organizado, con descripciones e
          imágenes bien detalladas de cada producto, para comprar cómodamente
          desde su hogar o celular y recibir los productos en su domicilio a un precio justo y de una forma práctica,
          rápida y garantizada.
          <br> <br>
          En CLAVE queremos seguir mejorando, sabemos que aún con toda la emoción y esfuerzo hecho hasta ahora, seguimos
          teniendo limitaciones. En algunos instrumentos nuestro catálogo
          aún no es tan amplio como deseamos, sin embargo, tenemos la decisión firme ofrecer cada vez más opciones a
          todos los instrumentistas de aliento. Cada músico, puede navegar y
          llegar a la sección de la página donde estén los accesorios o instrumentos de su especialidad, viendo así
          todas las opciones con que contamos para escoger el artículo que requiere. Si el accesorio o instrumento que
          busca no se encuentra en nuestro catálogo, lo conseguimos. Estamos en contacto con las marcas más importantes
          en el mundo en esta especialidad, por lo que con gusto podemos hacer llegar al músico lo que realmente
          necesita.
          <br> <br>
          Aparte de todo lo anterior, lo que hace única a CLAVE, es que absolutamente todos los que trabajamos en esta
          tienda somos músicos y más aún, instrumentistas de aliento.
          Sabemos que el músico, aparte de un catálogo amplio, requiere en ocasiones asesoría personal. En el equipo de
          CLAVE estamos completamente dispuestos a ayudarlo.
          <br> <br>
          <hr>
          <br>
          <span style="font-style: italic;">"Cuando era estudiante, me di cuenta que las tiendas de música en México,
               aún en las ciudades grandes, se enfocaban en “vender” más que en ofrecer un servicio especializado
               con varias opciones para músicos que tocaban determinado instrumento. Frecuentemente visitaba las tiendas
               de música en la ciudad de México, aún las empresas más grandes contaban
               con una variedad muy pobre de determinados instrumentos o accesorios. Varias veces tuve que encargar a
               amigos que viajaban a otros países estuches o accesorios que no se podían
               conseguir en México o que estaban a precios fuera de proporción”. – Ernesto Treto, saxofonista y fundador
               de CLAVE."</span>

     </div>
</div>